module.exports = __webpack_public_path__ + "media/discovery-ui/assets/social/youtube-white-441c7545a6601b63a7917ec11bf41f47.svg";